/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramGeoControllerGetAllCountriesQueryResponse } from '../types/TelegramGeoControllerGetAllCountries.ts';

function getTelegramGeoGetAllCountriesUrl() {
  const res = { method: 'GET', url: `/api/telegram/geo/countries/all` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/countries/all}
 */
export async function telegramGeoGetAllCountries(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetAllCountriesQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetAllCountriesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
